// profile.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ProfileService } from '../services/profile-service';


export const profileGuard: CanActivateFn = (route, state) => {
  const profileService = inject(ProfileService);
  const router = inject(Router);
  
  if (profileService.hasProfileSelected()) {
    return true;
  }
  
  // Reindirizza a /profili se non si è selezionato un profilo 
  return router.createUrlTree(['/profili'], { 
  });
};
